import { actions, helpers, selectors } from 'app-webtech-core';
import { exitFullscreen, ccPrevSubmenu } from 'app-modules/player/actions';
import { DPAD_LEFT } from './types';
import { GUIDE_MAXIMIZED } from '../../base/feature-discovery';

const remoteControllerDPadLeftButtonAction = helpers.actions.actionCreator(DPAD_LEFT);

export const remoteControllerDPadLeftButtonThunkAction = () => async (dispatch, getState) => {
  const state = getState();
  const { isCCMenuOpen } = selectors.player.properties(state);
  const location = selectors.location.page(state);
  const focusedArea = selectors.application.focusedArea(state);

  // checks to see if the cc settings menu is open
  if (!isCCMenuOpen) {
    if (location === 'Vod' || location === 'Watch') {
      dispatch(actions.application.featureDiscovered(GUIDE_MAXIMIZED));
      if (focusedArea === 'SCHEDULE_LINES') {
        dispatch(actions.application.setFocusedArea('CATEGORY_LIST'));
      }
      await dispatch(remoteControllerDPadLeftButtonAction());
    }
  } else {
    // Goes to the previous menu
    await dispatch(ccPrevSubmenu());
  }
};
